export function removeEntriesWithUndefinedValue<T extends { [key: string]: any }> (obj?: T): Partial<T> | null {
  if (!obj) return null
  const entries = Object.entries(obj)

  const filteredEntries = entries.filter((entry) => entry[1])

  return Object.fromEntries(filteredEntries) as Partial<T>
}
